export default __webpack_public_path__ + "static/media/colin.a8fe7762.png";